<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <dark-Toggler class="d-none d-lg-block" />
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <template v-if="isAuthReady && !isAuthenticated">
        <b-button
          to="/login"
          variant="outline-primary"
        >
          Sign in
        </b-button>
      </template>
      <b-nav-item-dropdown
        v-else-if="isAuthReady && isAuthenticated"
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-flex user-nav navbar-user-nav">
            <b-avatar
              :src="userPicture"
              size="40"
              variant="light-primary"
              class="navbar-user-nav__avatar flex-shrink-0"
            />
            <div class="navbar-user-nav__info">
              <p class="user-name font-weight-bolder mb-0">
                {{ user.name ? user.name : user.email }}
              </p>
              <span class="user-status">{{ user.role === 'Customer' ? '' : user.role }}</span>
            </div>
          </div>
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          to="/profile"
        >
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="userLogout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BButton, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import { mapActions, mapGetters } from 'vuex'
import { normalizeImageUrl } from '@/libs/utils'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BButton,
    BAvatar,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isAuthenticated: 'auth/authenticated',
      isAuthReady: 'auth/bootstrapped',
    }),
    userPicture() {
      return normalizeImageUrl(this.user && this.user.picture)
    },
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
    }),
    async userLogout() {
      await this.logout()
      if (this.$ability) {
        this.$ability.update(initialAbility)
      }
      await this.$router.replace({ name: 'login' })
    },
  },
}
</script>
